/**
 * A function to create a log object for the 'dummyName' event (evid: 9500)
 *
 * @param {dummyNameParams} params - The parameters for this event
 * @return {LogObject<dummyNameParams>} LogObject<dummyNameParams>
 */
export function dummyName(params) {
    return { evid: 9500, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginConfirmAccountDetails' event (evid: 9501)
 *
 * Event description: The buttons the user clicked on the "confirm account details" pop-up
 *
 * @param {postLoginConfirmAccountDetailsParams} params - The parameters for this event
 * @property {string} flowType - Post-login flow type ("Confirm account details"/"Confirm email")
 * @property {GUID} user_id - the users uuid
 * @property {string} button - Which button the user clicked on ("Edit email"\"Edit phone"\"Not now"\"Confirm")
 * @return {LogObject<postLoginConfirmAccountDetailsParams>} LogObject<postLoginConfirmAccountDetailsParams>
 */
export function postLoginConfirmAccountDetails(params) {
    return { evid: 9501, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginChangeDetailsClickedContinue' event (evid: 9502)
 *
 * Event description: The user clicked "Continue" on the "Change your account email" pop up, this event includes the errors the user gets
 *
 * @param {postLoginChangeDetailsClickedContinueParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Method type the user confirms ("Email"\"Phone")
 * @property {string} error_info - The error the user got when he clicked "Continue" (If all good - then Null)
 * @return {LogObject<postLoginChangeDetailsClickedContinueParams>} LogObject<postLoginChangeDetailsClickedContinueParams>
 */
export function postLoginChangeDetailsClickedContinue(params) {
    return { evid: 9502, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginResendCode' event (evid: 9503)
 *
 * Event description: The user clicked on "resend code"
 *
 * @param {postLoginResendCodeParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Where to resend the code? ("Email"\"Phone")
 * @property {string} flow_type - Post login flow type ("Confirm details"\"Confirm Email"\"Recovery Phone"\"MFA")
 * @return {LogObject<postLoginResendCodeParams>} LogObject<postLoginResendCodeParams>
 */
export function postLoginResendCode(params) {
    return { evid: 9503, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginVerifyDetails' event (evid: 9504)
 *
 * Event description: The user clicked on "Verify"
 *
 * @param {postLoginVerifyDetailsParams} params - The parameters for this event
 * @property {GUID} uuid - Users UUID
 * @property {string} methodType - Where to resend the code? ("Email"\"Phone")
 * @property {string} error_info - The error the user got when he clicked "Verify" (If all good - then Null)
 * @property {string} flow_type - Post login flow type ("Confirm details"\"Confirm Email"\"Recovery Phone"\"MFA")
 * @return {LogObject<postLoginVerifyDetailsParams>} LogObject<postLoginVerifyDetailsParams>
 */
export function postLoginVerifyDetails(params) {
    return { evid: 9504, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginConfirmDetailsDone' event (evid: 9505)
 *
 * Event description: The user clicked on the "Done" button in the "Confirm details" flow
 *
 * @param {postLoginConfirmDetailsDoneParams} params - The parameters for this event
 * @property {string} changes - What changes the user made (nothing - null\"Phone number"\"Email"\"Email and phone number")
 * @property {GUID} user_id - the users uuid
 * @return {LogObject<postLoginConfirmDetailsDoneParams>} LogObject<postLoginConfirmDetailsDoneParams>
 */
export function postLoginConfirmDetailsDone(params) {
    return { evid: 9505, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginRecoveryPhoneDetails' event (evid: 9506)
 *
 * Event description: The buttons the user clicked on the "Confirm recovery phone number" pop-up
 *
 * @param {postLoginRecoveryPhoneDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} phone_type - The phone number type the user chosen before clicking "next" ("Billing Phone number"\"Recover Phone number"\"New number"\Null when clicking "Not now")
 * @property {string} button - Which button the user clicked on ("Not now"\"Next")
 * @property {string} error_info - The error the user got when he clicked "Next" (If all good - then Null)
 * @return {LogObject<postLoginRecoveryPhoneDetailsParams>} LogObject<postLoginRecoveryPhoneDetailsParams>
 */
export function postLoginRecoveryPhoneDetails(params) {
    return { evid: 9506, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginMfaDetails' event (evid: 9507)
 *
 * Event description: The buttons the user clicked on the "2-step verification" pop-up
 *
 * @param {postLoginMfaDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} phone_type - Deprecated
 * @property {string} button - Which button the user clicked on ("Next"\"Not now")
 * @property {string} mfa_type - The 2fa type ("Phone")
 * @property {string} error_info - The error the user got when he clicked "Next" (If all good - then Null)
 * @property {string} type - The type for each 2FA, for example - The phone number type the user chosen before clicking "next" ("Billing Phone number"\"Recover Phone number"\"New number"\Null when clicking "Not now")
 * @return {LogObject<postLoginMfaDetailsParams>} LogObject<postLoginMfaDetailsParams>
 */
export function postLoginMfaDetails(params) {
    return { evid: 9507, src: 5, endpoint: 'post-login', params: params };
}
/**
 * A function to create a log object for the 'postLoginChangeYourPasswordDetails' event (evid: 9508)
 *
 * Event description: The buttons the user clicked on the "Change your password" pop-up
 *
 * @param {postLoginChangeYourPasswordDetailsParams} params - The parameters for this event
 * @property {GUID} user_id - the users uuid
 * @property {string} button - Which button the user clicked on ("Not now"\"Save"\"Forgot Password")
 * @property {string} error_info - The error the user got when he clicked "Save" (If all good - then Null)
 * @property {string} flow_type - Users flow type ("Create password"\"Update password")
 * @return {LogObject<postLoginChangeYourPasswordDetailsParams>} LogObject<postLoginChangeYourPasswordDetailsParams>
 */
export function postLoginChangeYourPasswordDetails(params) {
    return { evid: 9508, src: 5, endpoint: 'post-login', params: params };
}
//# sourceMappingURL=index.js.map